import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Logo } from "@/components/moveload/Logo";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b border-border/60 bg-background/70 backdrop-blur-xl sticky top-0 z-40">
        <div className="container flex h-16 items-center justify-between gap-2">
          <Logo />
          <nav className="hidden md:flex items-center gap-1 text-sm font-medium">
            {LINKS.map(l => (
              <Link key={l.to} to={l.to} className="px-3 py-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors">{l.label}</Link>
            ))}
          </nav>
          <div className="hidden sm:flex items-center gap-2">
            <Button variant="ghost" asChild><Link to="/auth/login">Log in</Link></Button>
            <Button asChild variant="hero"><Link to="/auth/signup">Get started</Link></Button>
          </div>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Open menu" className="md:hidden min-h-11 min-w-11">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[82vw] max-w-xs">
              <nav className="mt-8 flex flex-col gap-1 text-base font-medium">
                {LINKS.map(l => (
                  <Link key={l.to} to={l.to} className="rounded-lg px-3 py-3 min-h-11 hover:bg-secondary transition-colors">{l.label}</Link>
                ))}
              </nav>
              <div className="mt-6 flex flex-col gap-2">
                <Button variant="outline" asChild className="min-h-11"><Link to="/auth/login">Log in</Link></Button>
                <Button asChild variant="hero" className="min-h-11"><Link to="/auth/signup">Get started</Link></Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </header>

      <main className="flex-1"><Outlet /></main>
      <footer className="border-t border-border py-10 bg-secondary/30">
        <div className="container flex flex-col md:flex-row justify-between gap-6 text-sm text-muted-foreground">
          <div><Logo /><p className="mt-3 max-w-xs">The intelligent freight operating system. African-born, globally scalable.</p></div>
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-10">
            <div><p className="font-semibold text-foreground mb-2">Platform</p><Link to="/about" className="block py-1 hover:text-foreground">About</Link><Link to="/pricing" className="block py-1 hover:text-foreground">Pricing</Link><Link to="/contact" className="block py-1 hover:text-foreground">Contact</Link></div>
            <div><p className="font-semibold text-foreground mb-2">Get started</p><Link to="/auth/signup?role=shipper&src=footer" className="block py-1 hover:text-foreground">Book a Load</Link><Link to="/auth/signup?role=transporter&src=footer" className="block py-1 hover:text-foreground">Join as Transporter</Link><Link to="/contact" className="block py-1 hover:text-foreground">Request Demo</Link></div>
          </div>
        </div>
        <p className="container mt-8 text-xs text-muted-foreground">© {new Date().getFullYear()} Moveload. All rights reserved.</p>
      </footer>
    </div>
  );
}
